"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userPrivilegesDefaultValue = void 0;
exports.userPrivilegesDefaultValue = {
    isPaidCustomer: false,
    role: 'user',
    tier: 'free',
};
//# sourceMappingURL=userPrivileges.js.map